import IRoleHwrc from "interfaces/models/IRoleHwrc";
import IClaimHwrc from "interfaces/responses/IClaimHwrc";

const mapHwrcClaimToRole = (claim : IClaimHwrc) : IRoleHwrc => {
  const role : IRoleHwrc = {
    roleId: claim.id,
    roleName: claim.displayName
  };

  return role;
};

export { mapHwrcClaimToRole };
